import type { FaireProductEntity } from "../../entity_types/product";

export const p_7wgdf945vc: FaireProductEntity = {
  token: "p_7wgdf945vc",
  type: "product",
  name: "CARRY ON- Denim Pocket Boots w/ Frayed Texture",
  brandToken: "b_mz3xxxsvnf",
  brandName: "Lemonade Shoes",
  imageUrl:
    "https://cdn.faire.com/fastly/8c9ce359ddc0f31fac7bf19dd9f63df9186a8c432f2d837d8eee12d1a63d4f02.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7c10d0ab41ea50c4420ec3ea85847e94dfec893f20240cb1484135223979d43b.jpeg",
    "https://cdn.faire.com/fastly/51bdab3891541172667fb4f5307abec17b73e3288e65647ec6bbde11b0d4d4d5.jpeg",
    "https://cdn.faire.com/fastly/c555535bd3e5de15c119f38211c06d5457b391ef2ee59ca8daf94fac958ec958.jpeg",
    "https://cdn.faire.com/fastly/bd63f405fd899c0cb2bbcc8dd64a7a1af2346c1f2d17fc07a6ce9d23db198166.jpeg",
    "https://cdn.faire.com/fastly/5cf12591f0ce34dc7fcdebe851cc999bf520eb57245c9e2380dc6f339f4c275b.jpeg",
    "https://cdn.faire.com/fastly/ffca1c310d4e848ec35fb0a3289c350dfa7cb981d4f5b61cd958215c3c519e80.jpeg",
    "https://cdn.faire.com/fastly/49e5f3ab5771f12a617139db136b2aacb208e3522978c5d46c1630a1a1b55b26.jpeg",
    "https://cdn.faire.com/fastly/e85e94b90861cda300ba76a2c982579f7abf456153fa9721fac80552d13b46f3.jpeg",
    "https://cdn.faire.com/fastly/eec0993765546e124f5a31cb3eace690ebedf04887d5090e0a79d61ea98ac3d9.jpeg",
    "https://cdn.faire.com/fastly/cb42595a45f9df69e5bcaa37acb7bf8cf245777918f6333b199a514e0505e800.jpeg",
  ],
  priceDollars: 28.5,
  description:
    "The Carry On boots redefine denim with a bold, utilitarian edge. Featuring stacked cargo-style pockets, frayed detailing, and a sleek pointed toe, these boots bring a rugged yet fashion-forward aesthetic. The sharp stiletto heel contrasts the distressed denim, adding a touch of high-fashion drama.\n\nAvailable in classic black and light-wash denim, the Carry On boots are perfect for edgy streetwear looks, festival outfits, or making a bold statement with denim-on-denim styling.\n\n• Knee high boot\n• Metal stiletto heel\n• Pocket and distress detailing\n• Colors: black, blue",
  tags: [],
  msrpDollars: 57,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:49:18.988Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
